<template>
  <div id="fixedBox" :class="{ 'to-fixed': isFixed }">
    <div class="bg-white hot-post-top10 pb10 mb10">
      <div class="post-title mb10">
        <div>热门</div>
        <span v-if="hyhFlag" class="el-icon-refresh-right" @click="hyhBtn">换一换</span>
      </div>
      <hot-post
        v-for="(item, i) in articleHotDataList"
        :key="i"
        :hotDataList="item"
        :index="i"
        :page="hotPage"
      ></hot-post>
    </div>
    <com-foot></com-foot>
  </div>
</template>

<script>
import HotPost from "@/components/HotPost.vue";
import ComFoot from "@/components/Footer.vue";
export default {
  name: "ComFooter",
  data() {
    return {
      isFixed: false,
      hotPage: 1,
      hotPages: "",
      hyhFlag:false,
      articleHotDataList: []
    };
  },
  components: {
    HotPost,
    ComFoot
  },
  methods: {
    hotData() {
      this.$api
        .articleList({
          channelId: 0,
          current: this.hotPage,
          size: 10,
          type: 4,
        })
        .then((res) => {
          this.articleHotDataList = res.data.data.records;
          this.hotPages = res.data.data.pages;
          if(res.data.data.pages > 1) {
            this.hyhFlag=true
          }
        });
    },
    hyhBtn() {
      if (this.hotPage <= this.hotPages) {
        this.hotPage = this.hotPage == 1 ? 2 : 1;
        this.hotData();
      }else {
        this.hyhFlag = false
      }
    }
  },
  created() {
    this.hotData();
  },
  mounted() {
    let domH = document.getElementById("fixedBox").offsetTop;
    window.addEventListener("scroll", () => {
      if(document.getElementById("fixedBox")){
        let scrollY = document.documentElement.scrollTop;
        if(scrollY>domH){
          this.isFixed = true
        }else{
          this.isFixed = false
        }
      }
    });
  }
};
</script>

<style scoped lang="scss">
.hot-post-top10 {
  color: #121212;
  .post-title {
    font-size: 18px;
    font-weight: 600;
    padding: 18px 11px 18px 40px;
    background: url("../assets/images/icon/hot.png") center left 10px
      no-repeat;
    border-bottom: 1px solid #efefef;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      font-size: 18px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
      cursor: pointer;
    }
  }
}
.to-fixed{
  position: fixed;
  top: 60px;
  width: 310px;
}
</style>



// WEBPACK FOOTER //
// src/components/ComFoot.vue